module.exports = __webpack_public_path__ + "img/chevron-left.3f4c9b84.svg";